(function () {
  /* Show intro only on first visit per session */
  if (sessionStorage.getItem('snsei-intro-seen')) return;
  sessionStorage.setItem('snsei-intro-seen', '1');

  var overlay = document.createElement('div');
  overlay.id = 'snsei-intro';
  overlay.innerHTML =
    '<div class="snsei-intro__inner">' +
      '<svg class="snsei-intro__logo" viewBox="0 0 120 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<text x="50%" y="18" text-anchor="middle" font-family="Cormorant Garant, Georgia, serif" ' +
          'font-size="18" font-weight="200" letter-spacing="8" fill="rgba(255,255,255,0.9)">SENSEI</text>' +
      '</svg>' +
      '<div class="snsei-intro__line"></div>' +
    '</div>';

  var style = document.createElement('style');
  style.textContent =
    '#snsei-intro{' +
      'position:fixed;inset:0;background:#0c0c0c;z-index:99999;' +
      'display:flex;align-items:center;justify-content:center;' +
      'animation:snsei-intro-out 0.7s cubic-bezier(0.76,0,0.24,1) 1.6s both;' +
      'pointer-events:none;' +
    '}' +
    '@keyframes snsei-intro-out{' +
      'from{opacity:1;transform:none}' +
      'to{opacity:0;transform:translateY(-8px)}' +
    '}' +
    '.snsei-intro__inner{text-align:center;}' +
    '.snsei-intro__logo{' +
      'display:block;width:160px;height:auto;' +
      'opacity:0;animation:snsei-intro-logo 0.9s cubic-bezier(0.16,1,0.3,1) 0.2s both;' +
    '}' +
    '@keyframes snsei-intro-logo{' +
      'from{opacity:0;transform:translateY(10px)}' +
      'to{opacity:1;transform:none}' +
    '}' +
    '.snsei-intro__line{' +
      'width:0;height:1px;background:rgba(201,169,110,0.5);margin:16px auto 0;' +
      'animation:snsei-intro-line 0.8s cubic-bezier(0.16,1,0.3,1) 0.7s both;' +
    '}' +
    '@keyframes snsei-intro-line{' +
      'from{width:0;opacity:0}to{width:48px;opacity:1}' +
    '}';

  document.head.appendChild(style);
  document.body.appendChild(overlay);

  setTimeout(function () {
    if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
  }, 2500);
})();
